import classNames from 'classnames'
import { useApp } from '../../../hooks/useApp'
import { getMainProductVariantById } from '../../../utils'

interface Props {
  className?: string
}

export const SelectedVariantGallery = ({ className }: Props) => {
  const { mainProduct, activeMainProductVariantId } = useApp()
  const activeMainProductVariant = getMainProductVariantById(mainProduct, activeMainProductVariantId)

  const gallery = activeMainProductVariant.gallery ?? []

  const galleryImageUrls = gallery.length > 1
    ? gallery.slice(1)
    : []

  if (galleryImageUrls.length === 0) {
    return null
  }

  return (
    <ul className={classNames('builder-gallery pt-5 xl:pt-0 xl:grid xl:grid-cols-2 xl:gap-5 xl:px-5', className)}>
      {galleryImageUrls.map((url, index) => (
        <li key={`${activeMainProductVariant.id}-${index}`} className="builder-gallery__item">
          <img
            className="rounded-sm w-full"
            src={url}
            alt={activeMainProductVariant.metafields.title || activeMainProductVariant.title}
          />
        </li>
      ))}
    </ul>
  )
}